import React from "react";
import "./Services.css";

function Services() {
  const services = [
    {
      title: "Residential Construction",
      description:
        "We specialize in building high-quality homes, apartments, and villas. From foundation to finishing, we ensure every project meets modern design standards and client satisfaction.",
      icon: "🏠"
    },
    {
      title: "Commercial Buildings",
      description:
        "We design and construct corporate offices, malls, and hotels that combine durability with functionality. Our focus is on energy efficiency and modern architecture.",
      icon: "🏢"
    },
    {
      title: "Industrial Projects",
      description:
        "Our team delivers warehouses, factories, and large-scale industrial setups with advanced safety features and cost-effective construction methods.",
      icon: "🏭"
    },
    {
      title: "Interior Design",
      description:
        "We create beautiful interiors that match client preferences. From modern office spaces to luxury living rooms, we provide complete interior design solutions.",
      icon: "🛋️"
    },
    {
      title: "Renovation & Remodeling",
      description:
        "Breathe new life into your old spaces. Whether it's a home, office, or commercial building, we renovate with modern materials and innovative designs.",
      icon: "🔨"
    },
    
    {
      title: "Consultancy & Planning",
      description:
        "Our expert architects and engineers provide planning, 3D modeling, and consultancy services to bring your dream project to life.",
      icon: "📐"
    },
  ];

  return (
    <div className="services-page">
      <header className="services-header">
        <h1>Our Services</h1>
        <p>
          We provide end-to-end construction solutions covering residential,
          commercial, and industrial needs. Our mission is to deliver quality,
          durability, and design excellence.
        </p>
      </header>

      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
